import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'app-weave-checkbox',
    templateUrl: './weave-checkbox.component.html',
    styleUrls: ['./weave-checkbox.component.scss'],
    standalone: false
})
export class WeaveCheckboxComponent implements OnInit, OnChanges {
  @Input() data: boolean;
  @Input() value: string;
  @Input() label: string;
  @Input() disabled: boolean = false;
  @Input() showLabel: boolean = true;
  @Input() classList: string = '';

  @Output() changed: EventEmitter<string> = new EventEmitter<string>();
  id: string = "";
  constructor() { }

  ngOnInit(): void {
    this.id = "weave-checkbox-" + uuidv4();
  }
  ngOnChanges( changes: SimpleChanges ) {
    //todo SOS update data
    if( changes.data ) {
      this.data = changes.data.currentValue;
    }
  }

  toggleCheckbox() {
    this.data = !this.data;
    this.changed.emit(this.value);
  }

}
